import { ColumnConfig } from '../DataGrid.types'

export function getColumnsGroupingSetup<RowType>(columns: ColumnConfig<RowType>[]) {
  const hasColumnGrouping = columns.some(column => Boolean(column.groupId))
  const everyColumnHasGroup = hasColumnGrouping && columns.every(column => Boolean(column.groupId))

  return { hasColumnGrouping, everyColumnHasGroup }
}

export function getColumnInfo<RowType>({
  columnIndex,
  columns,
  pinnedColumns,
  pinnedColumnsRight,
}: {
  columnIndex: number
  columns: ColumnConfig<RowType>[]
  pinnedColumns: number
  pinnedColumnsRight: number
}) {
  const column = columns[columnIndex]
  const isLastColumn = columnIndex === columns.length - 1
  return {
    isLastColumn,
    isLastPinnedLeftColumn: columnIndex + 1 === pinnedColumns,
    isLastColumnInTheGroup:
      (isLastColumn && Boolean(column.groupId)) ||
      (columnIndex < columns.length - 1 &&
        columns[columnIndex + 1] &&
        columns[columnIndex + 1].groupId !== column.groupId),
    isFirstPinnedRightColumn: columnIndex === columns.length - pinnedColumnsRight,
  }
}
